import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { BieMoney } from './BieValue';

type Props = { summary?: any };

class BieExecutiveCardsPanel extends React.PureComponent<Props> {
  renderMetric(label: string, value: any, money = true) {
    return (
      <Grid size={{ xs: 12, sm: 6, md: 2 }} key={label}>
        <Card elevation={1}><CardContent>
          <Typography variant="caption" color="text.secondary">{label}</Typography>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>{money ? <BieMoney value={value} /> : value}</Typography>
        </CardContent></Card>
      </Grid>
    );
  }

  render() {
    const s = this.props.summary || {};
    return (
      <Grid container spacing={2}>
        {this.renderMetric('Sales', s.sales ?? s.ventes ?? s.venthydval)}
        {this.renderMetric('Purchases', s.purchases ?? s.achats ?? s.achathydval)}
        {this.renderMetric('OPEX', s.opex)}
        {this.renderMetric('Salaries', s.salaries ?? s.salaires)}
        {this.renderMetric('Partial Result', s.partialresult ?? s.resultatpartiel)}
        {this.renderMetric('Objective Gaps', s.objectivegaps ?? s.gapcount ?? 0, false)}
      </Grid>
    );
  }
}
export default BieExecutiveCardsPanel;
